module.exports = __webpack_public_path__ + "static/img/PIASTRIX.16c0566.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/payments/PIASTRIX.png
// module id = DdJL
// module chunks = 2